// styles
import "./styles/globals.css";

// antd react 19 support
import '@ant-design/v5-patch-for-react-19';

import { App } from '@/app';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <App />
    </StrictMode>,
)
